import { render } from "./serveurtables.vue?vue&type=template&id=56a29ce2"
import script from "./serveurtables.vue?vue&type=script&lang=js"
export * from "./serveurtables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__